import { useMemo } from "react"
import { getFragmentData } from "~/__generated__"
import { useCurrentUser } from "~/auth/CurrentUserContext"
import { CURRENT_SUBSCRIPTION_FRAGMENT } from "~/auth/currentUserQuery"
import { useTrackScreenEvent } from "~/common/useTrackScreenEvent"
import { LoadingIndicatorCentered } from "~/components/LoadingIndicator"

import { useDocumentTitle } from "~/common/useDocumentTitle"

export const OnboardingCheckoutSuccess = () => {
  useDocumentTitle("Processing Your Subscription")
  const currentUser = useCurrentUser()

  // Stripe returns here right after payment. The subscription may not have
  // synced yet, so fall back to the tier the user signed up for.
  const subscription = getFragmentData(
    CURRENT_SUBSCRIPTION_FRAGMENT,
    currentUser.activeSubscription
  )
  const tier = subscription?.tier?.key ?? currentUser.signupTierKey ?? ""
  const billingCycle =
    subscription?.tier?.billingCycle ?? currentUser.signupBillingCycle ?? ""

  useTrackScreenEvent(
    "checkout_completed",
    useMemo(() => ({ tier, billing_cycle: billingCycle }), [tier, billingCycle])
  )

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-2xl font-bold mb-4">
        Processing your subscription...
      </h1>
      <LoadingIndicatorCentered />
    </div>
  )
}
